import { render, staticRenderFns } from "./collecting-cases.vue?vue&type=template&id=7fbc0c48&scoped=true"
import script from "./collecting-cases.vue?vue&type=script&lang=ts"
export * from "./collecting-cases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc0c48",
  null
  
)

export default component.exports